angular.module('core')
  .constant('iOS', /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
